/**
 * Enable the Q1 2024 experimental interventions for login latency.
 * See https:www.notion.so/faire/Login-Latency-Reduction-Plan-Q1-2024-2da5f972eb534ea2b004248e3c40c89d?pvs=4
 * @deprecated Removed on backend, waiting for frontend removal
 */ export var ENABLE_EXPERIMENTAL_LOGIN_LATENCY_INTERVENTIONS_240119 = 'ENABLE_EXPERIMENTAL_LOGIN_LATENCY_INTERVENTIONS_240119';
